export default __webpack_public_path__ + "static/media/blues.37df972a.png";